module.exports = __webpack_public_path__ + "tk.svg?e994ec8618ddb499d7baaa07c572b8a1";